export default __webpack_public_path__ + "static/media/gallery_04.a2a37f4e.jpg";